import { useSelf } from 'App/components/hooks/appHooks';
import { addNotification, STYLE as notificationStyle } from 'Store/reducers/SystemNotificationReducer';
import { useAppDispatch } from 'App/components/hooks';

export default function MailCampaignAllowed() {
	const isAdmin = useSelf()?.administrator;
	const isMailAdmin = useSelf()?.userParams.mailAdmin;
	const isAllowed = isAdmin || isMailAdmin;
	const dispatch = useAppDispatch();

	if (!isAllowed) {
		dispatch(
			addNotification({
				title: 'default.error',
				body: 'errorNotFound.mailCampaign',
				style: notificationStyle.ERROR,
				icon: 'times'
			})
		);
	}

	return isAllowed || false;
}
